<template>
  <section :class="['hero', { 'image': filled === '' && !fetching }, { 'image-filled': filled !== '' && !fetching }, 'is-centered']">
    <template v-if="!isFreeSubscriptionActive || isFreeSubscriptionActive && isBlueBlockActive">
      <div v-if="!fetching" class="hero-body">
        <div class="container is-fluid">
          <p class="has-text-weight-bold has-text-centered is-size-6">TRUST<span class="has-text-weight-light">INDEX</span></p>
          <p class="has-text-centered has-text-weight-bold is-size-1" v-text="score"></p>
        </div>
      </div>
      <img v-if="fetching" class="stats-loader" src="/static/img/spinner.svg" alt="fetching Business stats..." />
    </template>
    <template v-else>
      <div class="is-visible"></div>
    </template>
  </section>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef */
  import axios from 'axios'
  import qs from 'qs'
  import misc from './../mixins/misc.js'

  export default {
    name: 'TrustIndexFrameWidget',
    mixins: [misc],
    props: {
      filled: {
        type: String,
        default: ''
      },
      slug: {
        type: String
      }
    },
    data () {
      return {
        score: 0,
        fetching: false
      }
    },
    created () {
      this.fetching = true
      this.getTrustIndex()
      this.getCurrentBusinessActiveSubscription()
    },
    methods: {
      getTrustIndex () {
        const queryString = qs.stringify({
          track_activity_action: 'trust.index.view',
          track_activity_event: 'WidgetActivity'
        })
        axios.get(`/${this.slug}/reports/trust-index?${queryString}`)
          .then(({data}) => {
            this.score = data.trustIndex
            this.fetching = false
          })
      }
    }
  }
</script>
<style scoped>
  .hero {
    width: 213px!important;
    height: 280px!important;
    margin: 0!important;
  }

  .one-px-border {
    border: 1px solid #cccccc;
  }

  .image, .image-filled {
    width: 215px;
    height: 280px;
    display: block;
    background-repeat: no-repeat;
    background-size: 215px 280px;
    margin-right: auto;
    margin-left: auto;
  }

  .image {
    background-image: url('/static/img/widgets/trust-index-1.0.svg');
  }

  .image-filled {
    background-image: url('/static/img/widgets/trust-index-2.0.svg');
    background-color: #2eaae1;
  }

  .image p {
    color: #2eaae1;
  }

  .image-filled p {
    color: #ffffff;
  }

  .hero-body {
    justify-content: center;
  }

  .hero-body > .container.is-fluid {
    margin-top: 55px;
  }

  .hero-body > .container.is-fluid > p:not(:first-child) {
    line-height: 3rem;
    font-weight: 900;
  }

  img.stats-loader {
    width: 40px;
    height: 40px;
    float: none;
    display: block;
    margin: auto;
  }
  .is-visible {
     background: rgb(49, 170, 225);
     height: 280px;
   }
</style>



// WEBPACK FOOTER //
// src/widgets/TrustIndexFrameWidget.vue